import * as React from "react";

const IconMenuWhite = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g
      id="ic/menu-w"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="sidebar">
        <polygon points="0 0 24 0 24 24 0 24" />
        <path
          d="M4,7 C4,6.44386482 4.4481055,6 5.00087166,6 L18.9991283,6 C19.5553691,6 20,6.44771525 20,7 C20,7.55613518 19.5518945,8 18.9991283,8 L5.00087166,8 C4.44463086,8 4,7.55228475 4,7 Z M4,12 C4,11.4438648 4.4481055,11 5.00087166,11 L18.9991283,11 C19.5553691,11 20,11.4477153 20,12 C20,12.5561352 19.5518945,13 18.9991283,13 L5.00087166,13 C4.44463086,13 4,12.5522847 4,12 Z M4,17 C4,16.4438648 4.4481055,16 5.00087166,16 L18.9991283,16 C19.5553691,16 20,16.4477153 20,17 C20,17.5561352 19.5518945,18 18.9991283,18 L5.00087166,18 C4.44463086,18 4,17.5522847 4,17 Z"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </svg>
);

export default IconMenuWhite;
